import { BehaviorSubject } from 'rxjs';
import { Socket } from 'socket.io-client';

import { SocketEventType, SocketMessage } from '.';

export class SocketImpl {
  constructor(private _socket: Socket) {
    // Register onAny to capture custom events (emitted by the server)
    this._socket.onAny((eventName, ...args) => {
      this._eventPipe.next({ eventName, message: args[0] as SocketMessage });
    });

    // Handle socket connection events on the io manager
    this.handleSocketErrors();
  }

  private _eventPipe = new BehaviorSubject<{ eventName: SocketEventType; message: SocketMessage }>({
    eventName: '' as SocketEventType,
    message: {} as SocketMessage,
  });
  private _connectionStatusPipe = new BehaviorSubject<boolean>(false);

  private get socket() {
    return this._socket;
  }

  events$ = this._eventPipe.asObservable();
  connectionStatus$ = this._connectionStatusPipe.asObservable();

  isConnected() {
    return this._socket.connected;
  }

  send(eventName: SocketEventType, message: SocketMessage) {
    this.socket.emit(eventName, message);
  }

  close() {
    this.socket.disconnect();
    this.socket.removeAllListeners();
    // Complete observables to allow garbage collection and signal subscribers
    this._eventPipe.complete();
    this._connectionStatusPipe.complete();
  }

  private handleSocketErrors() {
    // Listen for successful connection
    this.socket.on('connect', () => {
      console.debug('socket connected successfully');
      this._connectionStatusPipe.next(true);
    });

    // Listen for disconnection
    this.socket.on('disconnect', (reason: string) => {
      console.debug('socket disconnected:', reason);
      this._connectionStatusPipe.next(false);
    });

    // Listen for connection errors
    this.socket.on('connect_error', (error: Error) => {
      console.debug('socket connection error:', error);
      this._connectionStatusPipe.next(false);
    });

    this.socket.io.on('error', (error: Error) => {
      console.debug(`socket error: ${error.name} - ${error.message}`);
    });

    this.socket.io.on('reconnect_attempt', (attempt: number) => {
      console.debug('socket connection attempt:', attempt);
    });

    this.socket.io.on('reconnect_error', () => {
      console.debug('socket reconnection failed');
    });

    this.socket.io.on('reconnect_failed', () => {
      console.debug('socket reconnect failed after max attempts');
    });

    this.socket.io.on('reconnect', (attempt: number) => {
      console.debug('attempting to reconnect:', attempt);
    });
  }
}
